<template>
    <div class="operation">
        <Title chineseTitle="全部报警" englishTitle="Today's report to the police" />
        <div class="operationContent">
            <div class="all">
                <div class="title">报警总数</div>
                <div class="data">{{ alarms.length }}</div>
            </div>
            <div class="line"></div>
            <div class="detail">
                <div class="lineData" v-for="(item, index) in alarms" :key="index" @click="getCurrent(index)">
                    <div class="name">{{ item.loopName ? item.loopName : item.deviceName }}-{{ item.eventName }}</div>
                    <div class="time">{{ dateDiff((new Date(item.startTime)).getTime()) }}
                        <div class="position"></div>
                    </div>
                </div>
                <div v-if="alarms.length == 0">今日暂无报警事件</div>
            </div>
        </div>
    </div>
</template>

<script>
import Title from "@/components/Title.vue";
import DataItem from "@/components/DataItem";
import {
    GetTodayAlarmNum,
    GetAlarmList,
    getEventList
} from "@/components/Request";
import DateDiff from "@/components/DateDiff"

export default {
    name: "ParkOperationData",
    components: {
        Title,
        DataItem,
    },
    props: ["projectId"],
    data() {
        return {
            // deviceName: '',
            alarms: [],
            timer: null,
            alarm: {
                type: '遥测越限事件',
                area: 'A栋生产车间',
                text: '动力回路-过压报警',
                time: '一小时前',
            },
        }
    },
    mounted() {
        // this.getAlarmInfo()
        this.getEvents()
        this.timer = setInterval(() => this.getEvents(), 1000 * 60)
    },
    beforeDestroy() {
        this.timer && clearInterval(this.timer)
        this.timer && (this.timer = null)
    },
    methods: {
        dateDiff(value) {
            return DateDiff(value)
        },
        getAlarmInfo() {
            GetTodayAlarmNum({
                projectId: this.$store.state.projectId,
                d: 0
            }).then(({
                data
            }) => {
                if (data.data.num !== 0)
                    GetAlarmList({
                        projectId: this.$store.state.projectId,
                        size: data.data.num,
                        page: 1
                    }).then(({
                        data
                    }) => {
                        this.alarms = data.data.alarms
                        // console.log(this.alarms)
                        //.filter(item => new Date(item.start_time).toLocaleDateString === new Date().toLocaleDateString)
                    }).catch(err => {
                        console.log(err)
                    })
            }).catch(err => {
                console.log(err)
            })
        },
        getCurrent(value) {
            this.alarm.type = ''
            this.alarm.area = this.alarms[value].area_name
            this.alarm.text = this.alarms[value].loop_name || this.alarms[value].device_name + '-' + this.alarms[value].alarm_type_desc
            this.alarm.time = DateDiff((new Date(this.alarms[value].start_time)).getTime())
            this.$emit('showAlarmPosition', this.alarm)
        },
        async getEvents() {
            let res = await getEventList({
                page: 1,
                projectId: this.$store.state.projectId,
                size: 5000,
            })
            console.log(res);
            if (res.data.code == 200) {
                this.alarms = res.data.data.eventList.records
            } else {
                console.log(res.data.errMsg);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.operation {
    position: fixed;
    top: 880/108vh;
    left: 14600/192vw;
}

.operationContent {
    width: 4000/192vw;
    height: 1600/108vh;
    background: rgba(3, 13, 24, 0.75);
    margin-left: 1vw;
    padding: 160/108vh 100/192vw 160/108vh 220/192vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .all {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .title {
            font-size: 14rem;
            font-family: Source Han Sans CN;
            color: rgba(255, 255, 255, 0.7);
        }

        .data {
            font-size: 24rem;
            font-family: Source Han Sans CN;
            color: #FCFCFC;
        }
    }

    .line {
        width: 1px;
        height: 100%;
        background: rgba(255, 255, 255, 0.15);
    }

    .detail {
        width: 80%;
        height: 100%;
        font-size: 16rem;
        padding-left: 100/192vw;
        font-family: Source Han Sans CN;
        color: rgba(230, 243, 253, 0.7);
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        .lineData {
            // height: 100%;
            margin-bottom: 180/108vh;
            margin-right: 100/192vw;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            cursor: pointer;

            .name {
                width: 65%;
            }

            .time {
                width: 30%;
            }
        }
    }

    // .detail::-webkit-scrollbar {
    //     display: none;
    // }
}

.time {
    display: flex;
    align-items: center;
}

.position {
    .w(12);
    .h(15);
    margin-left: 5rem;
    background-image: url(../../assets/img/position.png);
    background-size: 100% 100%;
    display: inline-block;
}

.detail::-webkit-scrollbar {
    width: 50/192vw;
    height: 1px;
}

.detail::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.7);
}

// .detail::-webkit-scrollbar-track {
//     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//     border-radius: 10px;
//     background: #111;
// }
</style>